/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";
import ButtonWrapper from "dc-preview-utils/src/components/Button/ButtonWrapper";
import switchToDocViewIcon from "dc-icons/consumption/s_dock_hud_18.svg";
import switchBackToNormalViewIcon from "dc-icons/consumption/s_undock_hud_18.svg";
import * as constants from "constants/constants";

class DockHudUI extends Component {
  handleDocking() {
    this.props.onDockViewChange();
  }

  render() {
    const style = {};
    if (!this.props.isDocked && this.props.componentsOnRight.length) {
      style.marginRight = "8px";
    }

    return (
      <div style={style}>
        {this.props.isDocked ? (
          <ButtonWrapper
            icon={switchBackToNormalViewIcon}
            clickHandler={this.handleDocking.bind(this)}
            ariaLabel="arialabel.undockHud"
            tooltipString="tooltip.undockHud"
            tooltipPlacement={constants.TOOLTIP_TOP_PLACEMENT}
            tooltipDelay={constants.TOOLTIP_DELAY}
          />
        ) : (
          <ButtonWrapper
            icon={switchToDocViewIcon}
            clickHandler={this.handleDocking.bind(this)}
            ariaLabel="arialabel.dockHud"
            tooltipString="tooltip.dockHud"
            tooltipPlacement={constants.TOOLTIP_TOP_PLACEMENT}
            tooltipDelay={constants.TOOLTIP_DELAY}
          />
        )}
      </div>
    );
  }
}

export { DockHudUI };
